module.exports = __webpack_public_path__ + "assets/img/dishes5.eeb9937d.png";